import { SchemaFormDefinition } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { CalendarService } from '@optimus-web/core';
import { createSchema } from './schema';
import { disableDate } from './utils';

export const createFormDefinition = (calendarService: CalendarService) =>
    ({
        fields: {
            goLiveDate: {
                label: lt('OnboardingAuditGoLiveDateDialogTitle'),
                field: {
                    type: 'date',
                    mode: 'iso',
                    size: 'medium',
                    modifiers: {
                        disabled: (date) => disableDate(date, calendarService),
                    },
                },
                required: true,
            },
        },
    }) satisfies SchemaFormDefinition<ReturnType<typeof createSchema>>;
